import {createStateMaker} from '@shared/helpers/object'

import {APIStatus} from '@web/core/constants'

import {CashableReward, PointDescription, RewardPoint, RewardPointState, SubDetail} from './interfaces'

export const getInitialState = (): RewardPointState => ({
    amount: 0,
    cashPoint: 0,
    status: APIStatus.IDLE,
    maintenanceInfo: null,
    descriptions: [],
})

export const makeMock = createStateMaker<RewardPointState>(getInitialState)

export const getPoints = ({
    totalBalance,
    points = [],
}: {
    totalBalance: number
    points: {
        /** 포인트 명 */
        text: Maybe<string>
        /** 포인트 잔액 */
        balance: Maybe<number>
        /** 로고 이미지의 URL */
        logoImageUrl?: Maybe<string>
        /** 포인트의 상세정보 */
        rewardPointDescriptionDetails?: Maybe<SubDetail[]>
    }[]
}): PointDescription[] => {
    const pointsWithoutRewardPoint = points
        .filter((point) => point.text !== '네이버페이 포인트')
        .map(({text, balance, logoImageUrl, rewardPointDescriptionDetails}) => {
            return {
                type: RewardPoint.CASH_REWARD,
                cashType: CashableReward.VOUCHER,
                text: text ?? '',
                balance: balance ?? 0,
                logoImageUrl: logoImageUrl ?? '',
                subDetails: rewardPointDescriptionDetails ?? [],
            }
        })

    const totalVoucherBalance = pointsWithoutRewardPoint.reduce((acc, point) => {
        return acc + (point.balance ?? 0)
    }, 0)

    return [
        ...pointsWithoutRewardPoint,
        {
            type: RewardPoint.REWARD,
            cashType: null,
            text: '네이버페이 포인트',
            balance: totalBalance - totalVoucherBalance,
        },
    ]
}

export function getRewardStatus(success: boolean) {
    return success ? APIStatus.RESOLVED : APIStatus.REJECTED
}
